import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/cartDrawer.css";

const fmt = (n) => `MK ${n.toLocaleString()}`;
const getItemImage = (item) =>
  item.selImage || item.image || item.images?.[0] || item.colors?.[0]?.image || "";

export default function CartDrawer({ items, onClose, onRemove }) {
  const total           = items.reduce((sum, item) => sum + item.price * (item.qty || 1), 0);
  const navigate        = useNavigate();
  const { user, openSignIn } = useAuth();

  const handleCheckout = () => {
    if (!user) {
      sessionStorage.setItem("gvs_after_signin_path", "/checkout");
      openSignIn(() => {
        onClose();
        navigate("/checkout");
      });
    } else {
      onClose();
      navigate("/checkout");
    }
  };

  return (
    <>
      <div className="cart-overlay" onClick={onClose} />
      <div className="cart-drawer">
        <div className="cart-drawer__header">
          <span className="cart-drawer__title">Bag ({items.reduce((s, i) => s + (i.qty || 1), 0)})</span>
          <button className="cart-drawer__close" onClick={onClose}>✕</button>
        </div>

        {items.length === 0 ? (
          <p className="cart-drawer__empty">Your bag is empty.</p>
        ) : (
          <>
            <div className="cart-drawer__items">
              {items.map((item, i) => (
                <div key={i} className="cart-drawer__item">
                  <img
                    src={getItemImage(item)}
                    alt={item.name}
                    className="cart-drawer__thumb"
                  />
                  <div className="cart-drawer__item-info">
                    <p className="cart-drawer__item-name">{item.name}</p>
                    <p className="cart-drawer__item-meta">
                      {item.selColor} · Size {item.selSize}
                    </p>
                    <div className="cart-drawer__item-bottom">
                      <p className="cart-drawer__item-price">
                        {fmt(item.price * (item.qty || 1))}
                        {(item.qty || 1) > 1 && (
                          <span className="cart-drawer__qty"> × {item.qty}</span>
                        )}
                      </p>
                    </div>
                  </div>
                  <button className="cart-drawer__remove" onClick={() => onRemove(i)}>✕</button>
                </div>
              ))}
            </div>

            <div className="cart-drawer__footer">
              <div className="cart-drawer__total">
                <span>Subtotal</span>
                <strong>{fmt(total)}</strong>
              </div>
              <button className="cart-drawer__checkout-btn" onClick={handleCheckout}>
                Checkout →
              </button>
              <p className="cart-drawer__pay-note">Secured by Paychangu</p>
            </div>
          </>
        )}
      </div>
    </>
  );
}
